import config from '../config';
import { requestJson } from './http';

const toQuery = (params = {}) => {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
  ).toString();
  return query ? `?${query}` : '';
};

/**
 * Teams the user has played in, with members and aggregated stats.
 * @param {number|string} userId
 * @param {{ type?: 'PvP'|'PvE'|'Coop', sort?: 'recent'|'played'|'winRate' }} [params]
 */
export const getUserTeams = (userId, params) =>
  requestJson(`${config.apiUrl}/game-team/user/${userId}${toQuery(params)}`, {}, 'Failed to load your teams');

/**
 * Players the user has played with (teammates) and against (opponents).
 * @param {number|string} userId
 * @param {{ limit?: number }} [params]
 */
export const getUserTeammates = (userId, params) =>
  requestJson(
    `${config.apiUrl}/game-team/user/${userId}/teammates${toQuery(params)}`,
    {},
    'Failed to load your teammates'
  );

/**
 * Team members, stats and recent sessions (paginated).
 * @param {number|string} teamId
 * @param {{ limit?: number, offset?: number }} [params]
 */
export const getTeamProfile = (teamId, params) =>
  requestJson(`${config.apiUrl}/game-team/${teamId}/profile${toQuery(params)}`, {}, 'Failed to load team');

/**
 * Head-to-head records against other teams.
 * @param {number|string} teamId
 */
export const getTeamRivals = (teamId, params) =>
  requestJson(`${config.apiUrl}/game-team/${teamId}/rivals${toQuery(params)}`, {}, 'Failed to load rivals');

/**
 * Rename a team. Only members may rename; once per 24h (409 with `body.nextRenameAt`).
 */
export const renameTeam = (teamId, userId, teamName) =>
  requestJson(
    `${config.apiUrl}/game-team/${teamId}/name`,
    { method: 'PATCH', json: { userId, teamName } },
    'Failed to rename team'
  );

/**
 * Set the team emblem and/or color (send null to clear).
 */
export const updateTeamIdentity = (teamId, userId, { emblem, color }) =>
  requestJson(
    `${config.apiUrl}/game-team/${teamId}/identity`,
    { method: 'PATCH', json: { userId, emblem, color } },
    'Failed to update team'
  );
